import { Box, makeStyles, TextField, Typography } from '@material-ui/core';
import { useFormikContext } from 'formik';

const useStyles = makeStyles(() => ({
  characterCounter: {
    position: 'absolute',
    bottom: 40,
    right: 15,
  },
}));

export default function BodyFormFields() {
  const classes = useStyles();
  const formik = useFormikContext<{
    mensagem: string;
    rodape: string;
  }>();

  const mensagemLength = formik.values.mensagem.length || 0;
  const maxMensagemLength = 1024;

  const rodapeLength = formik.values.rodape.length || 0;
  const maxRodapeLength = 60;
  return (
    <>
      <Box position="relative">
        <TextField
          multiline
          name="mensagem"
          label="Mensagem"
          variant="outlined"
          minRows={3}
          maxRows={5}
          fullWidth
          helperText={
            (formik.touched.mensagem && formik.errors.mensagem) ||
            'Insira o texto da mensagem que deverá ser enviada.'
          }
          FormHelperTextProps={{
            style: { marginLeft: 0, paddingTop: 8 },
          }}
          value={formik.values.mensagem}
          inputProps={{
            maxLength: maxMensagemLength,
            style: { marginRight: 50, paddingBottom: 30 },
          }}
          onChange={formik.handleChange}
          error={formik.touched.mensagem && Boolean(formik.errors.mensagem)}
        />

        <Typography
          variant="caption"
          color="textSecondary"
          style={{ position: 'absolute', bottom: 40, right: 15 }}
        >
          {mensagemLength}/{maxMensagemLength}
        </Typography>
      </Box>

      <Box position="relative">
        <TextField
          name="rodape"
          label="Rodapé"
          variant="outlined"
          helperText={
            (formik.touched.rodape && formik.errors.rodape) ||
            'Adicione uma linha curta de texto abaixo de sua mensagem.'
          }
          value={formik.values.rodape}
          inputProps={{
            maxLength: maxRodapeLength,
            style: { marginRight: 50 },
          }}
          onChange={formik.handleChange}
          FormHelperTextProps={{
            style: { marginLeft: 0, paddingTop: 8 },
          }}
          fullWidth
        />

        <Typography
          variant="caption"
          color="textSecondary"
          className={classes.characterCounter}
        >
          {rodapeLength}/{maxRodapeLength}
        </Typography>
      </Box>
    </>
  );
}
